import { Button } from "@/modern/components/ui/button-shadcn";
import { PenBox, Plus } from "lucide-react";

interface EmptyChecklistsStateProps {
  onOpenEditor: (isCreatingNew: boolean) => void;
}

export const EmptyChecklistsState = ({ onOpenEditor }: EmptyChecklistsStateProps) => {

  return (
    <div className="h-full flex-1 flex flex-col py-4">
      <div className="h-full flex-1 flex flex-col items-center justify-center gap-6 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 px-8 py-8 text-center shadow-sm">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <PenBox className="size-6" />
        </div>
        <div className="space-y-2">
          <h3 className="text-base font-semibold text-foreground">No checklists yet
          </h3>
          <p className="text-sm text-muted-foreground min-h-[2.5rem] flex items-center">Create a checklist to track tasks, approvals, or punch items for this record.</p>
        </div>
        <Button onClick={() => onOpenEditor(true)} className="inline-flex items-center gap-2">
          <Plus className="size-4" />
          New Checklist
        </Button>
      </div>
    </div>
  );
};
